import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { SortableElement } from 'react-sortable-hoc';
import styled, { keyframes } from 'styled-components';
import { ImageType } from '@types';
import Image from '@components/Image';
import Icon from '@components/Icon';
import { getLibMediaData } from '@apis/mediaApis';
import ImgTrash from './img-trash.png';
import ImgText from './img-text.png';

interface Props {
  listIndex: number;
  src: string;
  mediaId: number;
  active?: boolean;
  withText?: boolean;
  onClick: (index: number) => void;
  onDeleteClick: (index: number) => void;
}

const marquee = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const Text = styled.p`
  display: inline-block;
  white-space: nowrap;
  animation: ${marquee} 5s linear infinite;
`;

function GalleryItem({
  listIndex,
  src,
  mediaId,
  active,
  withText,
  onClick,
  onDeleteClick,
}: Props) {
  const [name, setName] = React.useState('');
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    getLibMediaData(mediaId)
      .then((res) => {
        setName(res.name);
      })
      .catch(() => {});
  }, [mediaId]);
  return (
    <div
      className={classNames('relative m-5 h-60 w-60 focus:outline-none', {
        'ring-2 ring-orange': active,
      })}
      onClick={() => onClick(listIndex)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Image src={src} className="h-full w-full" type={ImageType.media} />
      <Icon
        src={ImgTrash}
        className="absolute right-5 top-5 cursor-pointer rounded-xs bg-black-border hover:bg-blue"
        onClick={(e) => {
          e.stopPropagation();
          onDeleteClick(listIndex);
        }}
      />
      {!!name && (
        <div
          className="absolute bottom-0 left-0 right-0 overflow-hidden bg-black-black bg-opacity-50 px-2 text-center text-sm text-white"
          title={name}
        >
          {isHovered ? <Text>{name}</Text> : <p className="truncate">{name}</p>}
        </div>
      )}
      {withText && <Icon src={ImgText} className="absolute right-5 bottom-5" />}
    </div>
  );
}

export default SortableElement(GalleryItem);
